import {
  Button,
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";
import { useEffect } from "react";

import useScreenType from "react-screentype-hook";

import { TitleWrapper } from "./Styles";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  disablePrimaryButton?: boolean;
  primaryLoading?: boolean;
  modalText?: string;
  modalTitle?: string;
  modalSubtitle?: string;
  children?: React.ReactNode;
  secondaryButtonText?: string;
  primaryButtonText?: string;
  onPrimaryButtonClicked?: () => void;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "xs" | "3xl" | "4xl" | "5xl" | "6xl" | "full";
  scrollBehavior?: "inside";
  cypressModalHeaderSelector?: string;
  isCentered?: boolean;
};
export const Modal = ({
  isOpen,
  onClose,
  modalTitle,
  modalText,
  children,
  secondaryButtonText,
  primaryLoading,
  disablePrimaryButton,
  primaryButtonText,
  onPrimaryButtonClicked,
  modalSubtitle,
  cypressModalHeaderSelector,
  size = "xl",
  ...props
}: Props) => {
  const { isMobile } = useScreenType();
  
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    const key = "__igniteOpenModalCount";
    const currentCount = Number(body.getAttribute(`data-${key}`) || "0");

    if (isOpen) {
      const nextCount = currentCount + 1;
      body.setAttribute(`data-${key}`, String(nextCount));
      body.classList.add("modal-open-hide-scrollbar");
      html.classList.add("modal-open-hide-scrollbar");
    }

    return () => {
      if (!isOpen) return;
      const latestCount = Number(body.getAttribute(`data-${key}`) || "1");
      const nextCount = Math.max(0, latestCount - 1);
      body.setAttribute(`data-${key}`, String(nextCount));
      if (nextCount === 0) {
        body.classList.remove("modal-open-hide-scrollbar");
        html.classList.remove("modal-open-hide-scrollbar");
      }
    };
  }, [isOpen]);

  return (
    <>
      <ChakraModal
        {...props}
        size={isMobile ? "full" : size}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        closeOnOverlayClick={true}
        closeOnEsc={true}
        blockScrollOnMount={true}
        preserveScrollBarGap={false}
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.5)" />
        <ModalContent margin="0">
          <ModalHeader>
            <TitleWrapper data-cy={cypressModalHeaderSelector}>{modalTitle}</TitleWrapper>
          </ModalHeader>
          {modalSubtitle && (
            <div style={{ paddingLeft: "24px" }}>
              <h2>{modalSubtitle}</h2>
            </div>
          )}
          <ModalCloseButton data-cy="cypress-modal-close-button-tap"/>
          {!children && <ModalBody>{modalText}</ModalBody>}
          {children && children}
          {(primaryButtonText || secondaryButtonText) && (
            <ModalFooter>
              {secondaryButtonText && (
                <Button mr={3} onClick={onClose} data-cy="cypress-cancel-modal-button-tap">
                  {secondaryButtonText}
                </Button>
              )}
              {primaryButtonText && (
                <Button
                  data-cy="cypress-submit-modal-button-tap"
                  type="submit"
                  isLoading={primaryLoading}
                  isDisabled={primaryLoading || disablePrimaryButton}
                  onClick={onPrimaryButtonClicked}
                  colorScheme="primary"
                >
                  {primaryButtonText}{" "}
                </Button>
              )}
            </ModalFooter>
          )}
        </ModalContent>
      </ChakraModal>
    </>
  );
};
